import React from 'react';
import { Coins } from 'lucide-react';
import { EmptyState } from './EmptyState';

export function CoOpCreditsEmpty({ coOpStatus, services, setActiveTab }) {
  if (!coOpStatus?.is_student || (coOpStatus.credits ?? 0) > 0) return null;
  const hasCoOpService = services.some((s) => s.co_op_tier);
  return (
    <div className="card-surface mb-6" data-testid="co-op-credits-empty">
      <EmptyState
        icon={Coins}
        testId="co-op-credits-empty-state"
        title="No Co-Op credits yet"
        body={hasCoOpService
          ? 'Your Co-Op service is live. Each session you complete with another student adds credits you can spend on their services.'
          : 'Offer one of your services at a Co-Op tier. Every session you complete with another student earns credits you can spend on theirs.'}
        actionLabel={hasCoOpService ? null : 'Add a Co-Op service'}
        onAction={() => setActiveTab('services')}
      />
    </div>
  );
}
